export default "__VITE_ASSET__6d0783cc__"